var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-icon-toggle-button",class:{ 'kd-icon-toggle-button--selected':  _vm.isSelected },on:{"click":_vm.toggle}},[_c('img',{staticClass:"kd-icon-toggle-button__icon",attrs:{"src":_vm.iconUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }